<template>
  <div class="app-container">
    <nav class="add-navigation">
      <div @click="$router.go(-1)" class="back-link">
        <svg
          class="icon"
          width="30px"
          height="30px"
          viewBox="0 0 30 30"
          version="1.1"
        >
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p>Back to Vendor Products</p>
      </div>
      <div class="buttons-wrapper">
        <div @click="$router.go(-1)" class="secondary-button">
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button">
          <primary-button @click.native="editVendor"
            >Save Vendor Product</primary-button
          >
        </div>
      </div>
    </nav>
    <div class="add-container">
      <span class="container-title">Edit Vendor Product Information</span>
      <div v-if="vendor" class="col-wrapper">
        <div class="col">
          <div class="help is-danger" v-if="vendorProdError">
            {{
              vendorProdError.user_name ? vendorProdError.user_name[0] : null
            }}
          </div>
          <primary-input
            type="text"
            name="vendor product name"
            class="field"
            v-model="vendor.vendor_product_name"
            v-validate="'required'"
            :class="{
              input: true,
              'is-danger': errors.has('vendor product name'),
            }"
            placeholder="Enter vendor product name"
          />
          <div class="help is-danger" v-if="errors.has('vendor product name')">
            {{ errors.first("vendor product name") }}
          </div>
          <div class="help is-danger" v-if="vendorProdError">
            {{
              vendorProdError.vendor_product_name
                ? vendorProdError.vendor_product_name[0]
                : null
            }}
          </div>
        </div>
        <div class="col">
          <primary-select
            type="text"
            name="smsc id"
            v-model="vendor.smsc_id"
            :options="smscConnections"
            v-validate="{
              required: true,
            }"
            :class="{ input: true, 'is-danger': errors.has('smsc_id') }"
          />

          <div v-if="errors.has('smsc_id')" class="help is-danger">
            {{ errors.first("smsc_id") }}
          </div>
          <primary-select
            v-if="vendor.type === 'http'"
            type="text"
            name="api adapter"
            v-validate="'required'"
            v-model="vendor.api_adapter_name"
            :class="{ input: true, 'is-danger': errors.has('api adapter') }"
            placeholder="api adapter"
          >
            <option
              v-for="(i, k) in api_adapters"
              :value="i.api_adapter_name"
              :key="k"
            >
              {{ i.api_adapter_name }}
            </option>
          </primary-select>
          <div v-if="errors.has('type')" class="help is-danger">
            {{ errors.first("api adapter") }}
          </div>
          <div class="help is-danger" v-if="vendorProdError">
            {{
              vendorProdError.api_adapter ? vendorProdError.api_adapter : null
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    AppDropzone: () => import("@/components/Dropzone"),
  },
  data: () => ({
    vendorProdError: null,
    api_adapters: [],
    smscConnections: [],
    vendor: null,
    checkPassowrd: null,
    vendor_product_id: null,
  }),
  computed: {
    ...mapGetters({
      viewVendor: "vendorProduct/getCurrentVendorProduct",
    }),
    ipAndPort() {
      return this.vendor.ip + ":" + this.vendor.port;
    },
  },
  created() {
    this.getSmscConnectionList();
    this.getVendorAccount();
    this.getApiAdapterList();
  },
  methods: {
    ...mapActions({
      getVendorProduct: "vendorProduct/getVendorProduct",
      editVendorProduct: "vendorProduct/editVendorProduct",
      updateVendorProduct: "vendorProduct/updateVendorProduct",
      getSmscConnection: "smsc/getSmscList",
    }),
    transformSmscC(item) {
      return {
        name: item.smsc_id,
        value: item.smsc_id,
      };
    },
    getVendorProd() {
      console.log("vendor");
      const {
        username,
        type,
        vendor_product_name,
        password,
        ip,
        api_adapter_name,
        port,
        smsc_id,
      } = this.viewVendor;

      return {
        username,
        type,
        vendor_product_name,
        password,
        ip,
        port,
        api_adapter_name,
        smsc_id,
      };
    },
    async getApiAdapterList() {
      let { total } = await this.$store.dispatch("GetApiAdapterList", {});
      const res = await this.$store.dispatch("GetApiAdapterList", {
        perPage: total,
      });
      this.api_adapters = res.items;
    },
    async getSmscConnectionList() {
      try {
        const res = await this.getSmscConnection({ page: 0 });
        const { total } = res;
        const res1 = await this.getSmscConnection({ page: 0, per_page: total });
        this.smscConnections = res.items.map(this.transformSmscC);
        console.log("smsc list");
        this.vendor = this.getVendorProd();
      } catch (err) {
        this.$error(err);
      }
    },
    async getVendorAccount() {
      const res = await this.getVendorProduct(
        this.$route.params.vendor_product_id
      );
    },
    editVendor: async function () {
      const valid = await this.$validator.validate();

      if (valid) {
        try {
          if (this.vendor.type !== "http") {
            this.vendor.api_adapter_name = null;
          }
          this.vendor.vendor_uuid = this.$route.params.id;
          // this.vendor.smsc_id = this.vendor.vendor_product_name;

          await this.editVendorProduct({
            vendor: this.vendor,
            id: this.$route.params.vendor_product_id,
          });

          this.$snotify.success("Vendor product has been added.", {
            timeout: 6000,
          });

          // this.$router.push({ name: "system-admin-vendor-accounts" });
          this.$router.go(-1);
        } catch (err) {
          if (err.errors) {
            this.vendorProdError = err.errors[0].password
              ? err.errors[0].password
              : null;
            setTimeout(() => {
              this.vendorProdError = null;
            }, 6000);
          } else {
            this.$snotify.error(
              err.response.data.errors
                ? err.response.data.errors
                : err.response.data.error.message,
              {
                timeout: 6000,
              }
            );
          }
        }
      }
    },
    handleChange(value) {
      let [ip = "", port = ""] = value.split(":");

      this.updateVendorProduct({ ip, port });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  font-family: "Helvetica Neue";
  padding: 0 20px;
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 210px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .add-container {
    flex-direction: column;
    align-items: center;
    height: fit-content;
    background-color: #ffffff;
    padding-top: 15px;
    .container-title {
      height: 30px;
      width: 432px;
      color: #000000;
      font-size: 16px;
      font-weight: 500;
      line-height: 30px;
      padding: 15px 0 15px 15px;
    }
    .col-wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      padding-left: 15px;
      .col {
        width: 100%;
        padding: 0;
        margin-right: 15px;
        .input {
          margin-bottom: 20px;
        }
        .field {
          p.pimary-input-title {
            color: #000000;
            font-family: "Helvetica Neue";
            font-size: 12px;
            font-weight: 900;
          }
        }
        .upload-photo,
        #dropzone {
          min-height: 285px;
          min-height: 285px;
          border-radius: 4px;
          width: 100%;
          .dz-image {
            padding: 5px;
            img {
              height: 150px;
              width: 150px;
              border-radius: 50px;
            }
          }
        }
        .pimary-input-title {
          color: #000000;
          font-family: "Helvetica Neue";
          font-size: 12px;
          font-weight: 900;
          letter-spacing: 0.21px;
          line-height: 15px;
          margin-bottom: 5px;
          text-transform: uppercase;
        }
        .upload-contaioner {
          border: 1px solid #5171f3;
          border-radius: 4px;
          background-color: #ffffff;
          height: 265px;
          border-style: dashed;
          margin-right: 15px;
          position: relative;
          input[type="file"] {
            position: absolute;
            height: 36px;
            width: 136px;
            opacity: 0;
            cursor: pointer;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            -ms-transform: translate(-50%, -50%); /* IE 9 fix */
            z-index: 1;
          }
          .upload-button {
            height: 36px;
            width: 136px;
            border-radius: 4px;
            background-color: #51a3f3;
            margin: 0;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
    .email-input {
      margin-bottom: 20px;
    }
    .password-input {
      margin-bottom: 30px;
    }
    .company {
      margin-bottom: 30px;
      .remember-me {
        display: flex;
        align-items: center;
        input {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>

